var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLightLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.456 0c0.001 0 0.001 0 0.002 0 0.098 0 0.188 0.040 0.252 0.105v0c0.064 0.066 0.104 0.156 0.104 0.255s-0.040 0.189-0.104 0.255l0-0-7.123 7.157 7.575 7.614c0.064 0.066 0.104 0.156 0.104 0.255s-0.040 0.189-0.104 0.255l0-0c-0.065 0.064-0.154 0.104-0.253 0.104s-0.188-0.040-0.253-0.104l0 0-7.819-7.868c-0.064-0.066-0.104-0.156-0.104-0.255s0.040-0.189 0.104-0.255l-0 0 7.362-7.413c0.063-0.065 0.151-0.105 0.249-0.105 0.003 0 0.005 0 0.008 0h-0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLightLeft);
export default __webpack_public_path__ + "static/media/chevron-light-left.306207a8.svg";
export { ForwardRef as ReactComponent };